export const PATHS = {
  ROOT: '/',
  LOGIN: '/login',
  SCORING: '/scoring/',
  SESSION_DETAILS: '/session',
  PRINTING_DASHBOARD: '/printing-dashboard',
  SCORING_DASHBOARD: '/scoring-dashboard',
  QUALITY_CONTROL: 'quality-control',
  SCORE_MATCHING: 'score-matching',
  CANDIDATES_SCORE_DISPLAY: 'candidates-scores-display',
  SCORING_VALIDATION: 'scoring-validation',
  CANDIDATE_OPTIONS: 'candidate-options',
  SCORE_EDIT: 'scoring-edit',
  SCORE_UPDATE: 'score-update/',
};
